import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle, Button, Box} from 'views/components';
import {TextCharLimit} from 'views/components';
import {Translate, translate} from 'views/module';

const CaregiverNameEdit = (props) => {
  const [newValue, setNewValue] = React.useState('');

  const {
    caregiverData,
    caregiverBackend,
    isEditing,
    setIsEditing,
  } = props;

  const {caregiverName} = caregiverData;

  React.useEffect(() => {
    setNewValue(caregiverName);
  }, [caregiverName]);

  const onSave = () => {
    caregiverBackend.detail.editName(newValue, () => {
      setIsEditing(false);
    });
  };

  const isValid = () => {
    return !Boolean(newValue);
  };

  const onClose = () => {
    setIsEditing(false);
  };

  return (
    <Dialog onClose={onClose} open={isEditing}>
      <DialogTitle onClose={onClose}>
        <Translate expression='caregiver.CaregiverDetail.ChangeName.Title' />
      </DialogTitle>
      <DialogContent>
        <Box sx={{m: 1}}>
          <TextCharLimit
            label={translate('caregiver.CaregiverDetail.ChangeName.Name')}
            value={newValue}
            onChange={setNewValue}
            charLimit={180}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="error" disabled={isValid()} onClick={onSave}>
          <Translate expression='generic.Save' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CaregiverNameEdit.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(CaregiverNameEdit);
